import { ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';

import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';
import { fetchHomepage } from 'client/ducks/homepage/actions';
import { getHomepage, isLoading } from 'client/ducks/homepage/selectors';
import { State } from 'client/store';
import { mapSizesToProps } from 'client/helpers/sizes';
import HomePage, { DispatchProps, StateProps } from './home';

function mapStateToProps(state: State): StateProps {
    return {
        data: getHomepage(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = { fetchHomepage };

const component = compose<ComponentType>(
    connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps),
    withSizes(mapSizesToProps)
)(HomePage) as any;

component.asyncFetchData = ({ dispatch }: AsyncFetchDataProps) => dispatch(fetchHomepage());

export default component;
